var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import './APAutoTabInput.css';
var baseClass = 'ap-auto-tab-input';
var InnerInput = function (_React$Component) {
  _inherits(InnerInput, _React$Component);
  function InnerInput(props) {
    _classCallCheck(this, InnerInput);
    var _this = _possibleConstructorReturn(this, (InnerInput.__proto__ || Object.getPrototypeOf(InnerInput)).call(this, props));
    _this.handleChange = function (e, index) {
      var target = e.target;
      var value = target.value;
      var maxLength = _this.props.maxLength;
      var newValues = _this.state.values.slice();
      if (value.length <= maxLength) {
        newValues[index] = value;
        _this.setNewValues(newValues);
      } else if (value.length > maxLength && index < _this.props.numberOfInputs - 1) {
        newValues[index + 1] = value.substr(value.length - 1, 1);
        _this.setNewValues(newValues);
      }
    };
    _this.handleKeyUp = function (e, index) {
      var backspaceCode = 8;
      if (e.keyCode === backspaceCode && e.target.value.length === 0) {
        var prev = e.target.previousElementSibling;
        while (prev) {
          if (prev === null) break;
          if (prev.tagName.toLowerCase() === 'input') {
            prev.focus();
            break;
          }
          prev = prev.previousElementSibling;
        }
      } else if (e.target.value.length === _this.props.maxLength) {
        var next = e.target.nextElementSibling;
        while (next) {
          if (next === null) break;
          if (next.tagName.toLowerCase() === 'input') {
            next.focus();
            break;
          }
          next = next.nextElementSibling;
        }
      }
    };
    _this.state = {
      values: Array(props.numberOfInputs).fill('')
    };
    return _this;
  }
  _createClass(InnerInput, [{
    key: 'setNewValues',
    value: function setNewValues(newValues) {
      var _this2 = this;
      this.setState({
        values: newValues
      }, function () {
        _this2.props.input.onChange(_this2.state.values.join(''));
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;
      var _props = this.props,
        info = _props.info,
        meta = _props.meta,
        label = _props.label,
        customClass = _props.customClass;
      var bemClasses = getBEMClasses(baseClass, customClass);
      var inputs = this.state.values.map(function (value, index) {
        return React.createElement('input', {
          key: index,
          className: bemClasses(),
          onKeyUp: function onKeyUp(e) {
            return _this3.handleKeyUp(e, index);
          },
          onChange: function onChange(e) {
            return _this3.handleChange(e, index);
          },
          value: _this3.state.values[index]
        });
      });
      return React.createElement('div', {
        className: 'form-group'
      }, this.props.type !== 'hidden' && label && React.createElement('label', {
        className: bemClasses('label')
      }, label), inputs, info && React.createElement('small', {
        className: 'form-text-muted'
      }, info), meta.touched && meta.error && React.createElement('span', {
        className: '' + bemClasses('error')
      }, meta.error));
    }
  }]);
  return InnerInput;
}(React.Component);
var APAutoTabInput = function APAutoTabInput(props) {
  return React.createElement(Field, Object.assign({
    name: props.name,
    component: InnerInput
  }, props));
};
APAutoTabInput.defaultProps = {
  maxLength: 1
};
APAutoTabInput.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  customClass: PropTypes.string,
  numberOfInputs: PropTypes.number.isRequired,
  maxLength: PropTypes.number
};
export default APAutoTabInput;